<template>
  <div id="app">
    <app-env v-if="isApp" />
    <router-view />
    <div v-if="showThirdPartyMask" class="third_party_mask">
      <div class="third_party_mask_bg"></div>
      <div class="third_party_mask_tip">
        <img :src="thirdPartyTipImg" alt="" />
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      list: ['agreement', 'policy', 'children', 'thirdparty'],
      autoLoginParams: null,
      // 主题色
      themeColor: {
        'bgcolor': '#fff', //网页背景色
        // 'theme': '#ff5c46', //平台保证，安心无忧 原来主题色
        'theme': '#f66f30',
        'themebgc': '#fff0e9', //平台保证，安心无忧背景色
        'theme50': '#ff5d47',
        'theme120': '#fb9283',
        'fade': '#ff625a', //顶部背景 渐变 深色
        'fade5': '#fd7d77',
        'fade10': '#3db6ff',
        'fade20': '#ff8b83', //顶部背景 渐变 浅色
        'red': '#fe3019', //红色 warning
        'enough': '#10a617', //充足
        'tint120': '#ff625a ', //底部tab 市场 
        'placeholder': '#bcbdc1', //placeholder
        'base': '#121213', //全局普通字体色
        'innerbgc': '#fbfbfb', //内容背景色 f2f3f5
        'mid20': '#62dbf8', //出售渐变
        'mid100': '#08a2fc',//出售渐变
        'warning': '#e79434', // warning,
        'active': '#e6f7ff', //选择底色,
        'xq': '#e7691d',//个人中心 详情按钮,
        'borderColor': '#fd7d77',
        'chooseBg': '#ffe1dd',
        'success': '#11a617',
        'confirm': '#ff5c46',
        'ing': '#2e75c3'
      },
      token: '',
      phone: '',
    }
  },
  created() {
    const { code, user_id } = this.getAutoLoginQuery()
    if (code && user_id) this.$store.commit('setAutoLogin', true)
  },
  mounted() {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`)
    // We listen to the resize event
    window.addEventListener('resize', () => {
      // We execute the same script as before
      let vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    })
    this.setThemeColor()
    this.checkAutoLogin()
  },
  computed: {
    showThirdPartyMask() {
      if (typeof navigator === 'undefined') return false
      const ua = navigator.userAgent || ''
      const thirdPartyPatterns = [
        /micromessenger/i, // 微信
        /wxwork/i, // 企业微信
        /\bqq\//i, // QQ 内置浏览器
        /dingtalk/i, // 钉钉
        /alipayclient/i, // 支付宝
        /weibo/i, // 微博
        /xhs-ios|xhs-android|xiaohongshu/i, // 小红书
        /newsarticle|toutiaomicroapp/i, // 今日头条/抖音系内置环境
        /aweme/i, // 抖音
        /ksnebula|kuaishou/i, // 快手
        /baiduboxapp/i, // 百度 App
      ]
      return thirdPartyPatterns.some(pattern => pattern.test(ua))
    },
    thirdPartyTipImg() {
      return require('./assets/version_1.3.8/tip.png')
    },
    gameId() {
      return this.$store.state.gameId
    },
    gameId_routename() {
      return {
        gameId: this.$store.state.gameId,
        route: this.$route.name
      }
    },
    isLogin_routename() {
      return {
        isLogin: this.$store.getters.isLogin,
        route: this.$route.name
      }
    },
    isLogin() {
      return this.$store.getters.isLogin
    },
    isApp() {
      return this.$store.state.isApp
    },
    code() {
      return this.$route.query.code
    }
  },
  methods: {
    getAutoLoginQuery() {
      const searchParams = new URLSearchParams(window.location.search || '')
      const hash = window.location.hash || ''
      const qIndex = hash.indexOf('?')
      const hashParams = qIndex > -1 ? new URLSearchParams(hash.slice(qIndex + 1)) : new URLSearchParams('')

      return {
        code: searchParams.get('code') || hashParams.get('code'),
        user_id: searchParams.get('user_id') || hashParams.get('user_id'),
        app_id: searchParams.get('app_id') || hashParams.get('app_id'),
        goKf: searchParams.get('goKf') || hashParams.get('goKf'),
      }
    },
    setThemeColor() {
      for (let key in this.themeColor) {
        document
          .getElementsByTagName("body")[0]
          .style.setProperty(`--${key}`, this.themeColor[key]);
      }
    },
    checkAutoLogin() {      
      this.$store.commit('setAutoLogin', true)
      this.$router.onReady(() => {        
        const routeQuery = this.$route.query || {}
        const urlQuery = this.getAutoLoginQuery()
        const code = routeQuery.code || urlQuery.code
        const user_id = routeQuery.user_id || urlQuery.user_id
        const app_id = routeQuery.app_id || urlQuery.app_id
        if (code && user_id) {
          this.autoLoginParams = { code, user_id, app_id }
          window.history.replaceState(Object.assign({}, window.history.state, { noBackFromEntry: true }), document.title, window.location.href)

          if (this.isLogin) {
            this.$store.dispatch('logout', 'silent')
          }
          
          this.$Ajax('user-info/get-box-userinfo', {
            code: this.autoLoginParams.code,
            user_id: this.autoLoginParams.user_id
          }).then(rs => {
            if (rs.code == 200) {
              this.token = rs.data.token
              this.phone = rs.data.phone
              if(!rs.data.exists) {
                this.$filterPop({
                  type: 'quickregister',
                  direction: 'up',
                  selection: { phone: this.phone, token: this.token },
                  onSuccess: () => {
                    this.clearAutoLoginParams(() => this.afterAuthSuccess())
                  }
                })
              }else {
                this.boxlogin(rs.data.token)
              }
            } else {
               this.$store.commit('setAutoLogin', false)
            }
          }).catch(() => {
             this.$store.commit('setAutoLogin', false)
          })

          if(!this.autoLoginParams.app_id) return
          this.$Ajax("game/app-list").then((rs) => {
            if (rs.code == 200) {
              const list = rs.data || [];
              const game = list.find(g => g.id == this.autoLoginParams.app_id);
              if (game) {
                const { app_name, icon, id, prop_trade, role_trade } = game;
                this.chooseGame(app_name, icon, id, prop_trade, role_trade);
              }
            }
          });
        } else {
          const q = this.getAutoLoginQuery()
          if (!(q.code && q.user_id)) {
            this.$store.commit('setAutoLogin', false)
          }
        }
      })
    },
    boxlogin(token) {
      this.$Ajax('user-info/login-by-39box', {
        token
      }).then(res => {
        if (res.code == 200) {
          this.$store.dispatch("setCookies", res.data);
          const isAndroid = this.$store.getters.ua.isAndroid
          if (isAndroid) {
            try {
              window.android.sendUserInfoWebToNative(JSON.stringify(res.data));
            } catch (error) {
              console.log(error);
            }
          } else {
            try {
              window.webkit.messageHandlers.sendUserInfoWebToNative.postMessage(JSON.stringify(res.data));
            } catch (error) {
              console.log(error);
            }
          }
          this.$toast({
            message: '登录成功',
            duration: 2000,
            onClose: () => {
              this.clearAutoLoginParams(() => this.afterAuthSuccess())
            }
          });
        } else {
          this.$store.commit('setAutoLogin', false)
        }
      }).catch(() => {
        this.$store.commit('setAutoLogin', false)
      })
    },
    clearAutoLoginParams(callback) {
      const query = { ...this.$route.query }
      delete query.code
      delete query.user_id
      if (query.app_id != null) delete query.app_id
      this.$router.replace({ query }, callback)
    },
    afterAuthSuccess() {
      if (this.shouldGoKf()) {
        this.goKf()
        return
      }
      window.location.reload()
    },
    shouldGoKf() {
      const routeGoKf = this.$route.query && this.$route.query.goKf
      const urlGoKf = this.getAutoLoginQuery().goKf
      return String(routeGoKf || urlGoKf) === '1'
    },
    goKf() {
      this.$store.dispatch("getUserData", true).then(() => {
        const userData = this.$store.state.userData || {}
        const url = 'https://livechathuyu.gmmsj.com/index/index/kefu?u=6265f471b483e&platform=8&game_id=8889&game_name=G买卖&uid=8_' + userData.user_id + '&phone=' + userData.username
        window.location.href = url
      }).catch(() => {
        window.location.reload()
      })
    },
    chooseGame(name, icon, id, prop_trade, role_trade) {
      this.$store.commit('resetServer')
      this.$store.commit('resetHomeServer')
      this.$store.commit('setGameInfo', {
        name,
        icon,
        id
      })

      this.$store.commit('setCt', '')
      this.$store.commit('setCi', '')
      this.$store.commit('setCt2', '')
      this.$store.commit('setCi2', '')
      //道具市场 角色市场判断
      this.$store.commit('setHome', { prop_trade, role_trade })
      if (prop_trade == 0) {
        this.$store.commit('changeHome', 2)
      } else {
        this.$store.commit('changeHome', 1)
      }
      //角色市场 筛选全部重置
      this.$store.commit('resetAccPx')
    },
  },
  watch: {
    // '$route': {
    //   immediate: true,
    //   handler(e) {
    //     if(!this.$store.getters.isLogin&&!this.list.includes(e.name)) {
    //       this.$toast('请先登录/注册')
    //       this.$router.push({name: 'user.login'})
    //     }
    //   }
    // },
    isLogin: {
      immediate: true,
      handler(e) {
        if (e) {
          this.$store.dispatch("getUserData", true)
        }
      }
    },
    'gameId_routename': {
      immediate: true,
      handler(e) {
        if (e.gameId) {
          if (e.name && e.name != 'acc.puton') {
            this.$store.commit('getGameInfo', e.gameId)
          }
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
#app {
  position: relative;
}

.third_party_mask {
  position: fixed;
  inset: 0;
  z-index: 99999;
}

.third_party_mask_bg {
  position: absolute;
  inset: 0;
  background-color: #595959;
}

.third_party_mask_tip {
  position: absolute;
  left: 50%;
  bottom: 4rem;
  transform: translateX(-50%);
  width: min(100%, 52.5rem);
  max-width: 450px;
  padding: 0 1.6rem;
  box-sizing: border-box;
  z-index: 1;
  img {
    display: block;
    width: 100%;
    height: auto;
  }
}
</style>
